/*@flow*/
import type { GoogleButton } from '../types';
import type { IntegrationContextT } from './types';

const commands = (ctx: IntegrationContextT): {|
  changeNav: (value: string) => void,
  editIntegration: (payload: GoogleButton) => void,
  finish: () => void,
  set: (path: string, value: any) => void,
  startNewIntegration: () => void,
|} => ({
  changeNav(value: string) {
    commands(ctx).set('navMode', value);
  },
  finish() {
    ctx.dispatch({
      type: 'FINISH',
    });
  },
  startNewIntegration() {
    ctx.dispatch({ type: 'NEW' });
  },
  editIntegration(payload: GoogleButton) {
    ctx.dispatch({ type: 'EDIT', payload });
  },
  set(path: string, value: any) {
    ctx.dispatch({
      type: 'SET_RECORD',
      payload: { path, value },
    });
  },
});

export default commands;
